export default {"src":"/_next/static/media/chevron-blue.fe9a9b04.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};